export const hideElement = (element) => { element.classList.add("d-none") }
export const showElement = (element) => { element.classList.remove("d-none") }

export const isElementContainedIn = (child, parent) => {
  const parentCoordinates = parent.getBoundingClientRect()
  const childCoordinates = child.getBoundingClientRect()

  const isContained = childCoordinates.top >= parentCoordinates.top &&
    childCoordinates.right <= parentCoordinates.right &&
    childCoordinates.bottom <= parentCoordinates.bottom &&
    childCoordinates.left >= parentCoordinates.left

  return isContained
}

export const isElementVerticallyContainedIn = (child, parent) => {
  const parentCoordinates = parent.getBoundingClientRect()
  const childCoordinates = child.getBoundingClientRect()

  const isContained = childCoordinates.top >= parentCoordinates.top &&
    childCoordinates.bottom <= parentCoordinates.bottom

  return isContained
}
